import { z } from 'zod';

export const divisionRoundingSchema = z.object({
  decimals: z.number().gt(0).int(),
  round_mode: z.union([z.literal('up'), z.literal('truncate')]),
});

type DivisionRoundingSchemaType = z.infer<typeof divisionRoundingSchema>;

const defaultValue: DivisionRoundingSchemaType = {
  decimals: 2,
  round_mode: 'truncate',
};

export const divisionRoundingDefaultValue = JSON.stringify(defaultValue, null, '\t');
